import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import moment from "moment";
import "moment/locale/tr";

class MachineCustomer2Detail extends Component {
  state = {
    pageTitle: "Makine Müşteri Detay",
    pageTitleDetail: "Makine Müşteri Detay",
    pageAddLink: "makine-musteri-2-ekle",
    pageListLink: "makine-musteri-2-listele",
    breadcrumb: [{ text: "Makine Müşteri", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    guid: "",
    customerName: "",
    machineSerialNo: "",
    brandName: "",
    modelName: "",
    saleTypeName: "",
    entryDate: "",
    endDate: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/machineCustomer2/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            customerName: response.data.customerName,
            machineSerialNo: response.data.machineSerialNo,
            brandName: response.data.brandName,
            modelName: response.data.modelName,
            saleTypeName: response.data.saleTypeName,
            entryDate: response.data.entryDate,
            endDate: response.data.endDate !== null ? moment(response.data.endDate).format("DD/MM/YYYY") : null,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Makine</th>
                    <td colSpan="4">
                      {this.state.machineSerialNo + " / " + this.state.brandName + " / " + this.state.modelName}
                    </td>
                  </tr>

                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Satış Türü</th>
                    <td colSpan="4">
                      {this.state.saleTypeName ? this.state.saleTypeName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Başlangıç Tarihi</th>
                    <td colSpan="4">
                      {this.state.entryDate}
                    </td>
                  </tr>

                  <tr>
                    <th>Bitiş Tarihi</th>
                    <td colSpan="4">
                      {this.state.endDate}
                    </td>
                  </tr>

                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default MachineCustomer2Detail;
